import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoCardModule } from 'mojo-card';
import { FeatureFlagsModule } from 'mojo-feature-flags';

import { MaterialModule } from '@material/material.module';
import { ContainerSizeModule } from '@shared/directives/container-size/container-size.module';
import { NumberPresenterV2Module } from '@shared/number-presenter-v2/number-presenter-v2.module';
import { NumberPresenterModule } from '@shared/number-presenter/number-presenter.module';
import { DaysPassedPipeModule } from '@shared/pipes/days-passed';
import { StatusModule } from '@shared/status/status.module';

import { CandidateTooltipModule } from '../candidate-tooltip/candidate-tooltip.module';
import { JobLocationModule } from '../job-location/job-location.module';
import { JobAggregationComponent } from './job-aggregation/job-aggregation.component';
import { JobItemComponent } from './job-item.component';
import { MatchedCandidatesActivityComponent } from './matched-candidates-activity/matched-candidates-activity.component';
import { MatchedCandidatesAvatarsComponent } from './matched-candidates-avatars/matched-candidates-avatars';
import { JobPublicationLabelModule } from '@shared/job-publication-label/job-publication-label.module';
import { SharedDirectivesModule } from '@shared/directives';

@NgModule({
  imports: [
    CommonModule,
    CandidateTooltipModule,
    MaterialModule,
    NumberPresenterModule,
    MojoAvatarModule,
    DaysPassedPipeModule,
    StatusModule,
    ContainerSizeModule,
    SharedDirectivesModule,
    MojoCardModule,
    JobLocationModule,
    FeatureFlagsModule,
    NumberPresenterV2Module,
    RouterModule,
    JobPublicationLabelModule,
  ],
  declarations: [
    JobItemComponent,
    JobAggregationComponent,
    MatchedCandidatesAvatarsComponent,
    MatchedCandidatesActivityComponent,
  ],
  exports: [
    JobItemComponent,
    JobAggregationComponent,
    MatchedCandidatesAvatarsComponent,
    MatchedCandidatesActivityComponent,
  ],
})
export class JobItemModule {}
